import { createFileRoute, Navigate } from '@tanstack/react-router';

const Page = () => {
  const params = Route.useParams();
  return (
    <Navigate
      params={{ advisoryOrganizationId: params.advisoryOrganizationId }}
      replace
      to='/organizations/$advisoryOrganizationId/plans'
    />
  );
};

export const Route = createFileRoute(
  '/organizations/$advisoryOrganizationId/edit'
)({
  component: Page
});
